<template>
  <div class="font-sans bg-[#f6f4f1] text-[#1f2937] min-h-screen flex flex-col">
    <!-- 🌟 HEADER -->
    <header class="bg-[#1a1a1a] text-white shadow sticky top-0 z-50">
      <div class="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
        <!-- LOGO -->
        <div class="flex items-center gap-2">
          <img src="/logo.png" alt="Logo" class="h-10 w-auto" />
          <span class="font-bold text-lg">GetLance</span>
        </div>

        <!-- MENU PRINCIPAL -->
        <nav class="hidden md:flex items-center gap-8">
          <a href="#sobre" class="hover:text-[#b99a52] transition">Sobre</a>
          <a href="#categorias" class="hover:text-[#b99a52] transition">Categorias</a>
          <a href="#seguranca" class="hover:text-[#b99a52] transition">Segurança</a>
          <a href="#como-funciona" class="hover:text-[#b99a52] transition">Como funciona</a>
        </nav>

        <!-- AÇÕES -->
        <div class="flex gap-3">
          <router-link
            to="/login"
            class="px-4 py-2 rounded-full border border-white/20 bg-white/10 hover:bg-white/20 transition"
          >
            Fazer login
          </router-link>
          <router-link
            to="/cadastro"
            class="px-4 py-2 rounded-full bg-[#b99a52] hover:bg-[#a18446] text-white transition"
          >
            Cadastrar
          </router-link>
        </div>
      </div>
    </header>

    <!-- 🟡 HERO -->
    <section
      class="relative flex-1 flex flex-col justify-center items-center text-center bg-cover bg-center"
      style="background-image: url('/banner-marketplace.jpg');"
    >
      <div class="absolute inset-0 bg-black/60"></div>

      <div class="relative z-10 max-w-3xl px-6">
        <h1 class="text-4xl sm:text-5xl font-extrabold text-white mb-4">
          Conectamos <span class="text-[#b99a52]">trabalhadores</span> e
          <span class="text-[#b99a52]">empresas</span>
        </h1>
        <p class="text-white/90 text-lg mb-8">
          Crie propostas, encontre profissionais qualificados e mova sua ideia do papel - tudo em um só lugar.
        </p>
        <div class="flex flex-col sm:flex-row gap-3 justify-center mb-8">
          <router-link
            to="/projetos"
            class="px-6 py-3 rounded-full bg-[#b99a52] hover:bg-[#a18446] text-white font-semibold transition"
          >
            Encontre Trabalho
          </router-link>
          <router-link
            to="/buscar-profissionais"
            class="px-6 py-3 rounded-full bg-white hover:bg-gray-200 text-[#152a34] font-semibold transition"
          >
            Encontre Trabalhadores
          </router-link>
        </div>
      </div>
    </section>

    <!-- 💼 SEÇÃO SOBRE -->
    <section id="sobre" class="py-20 bg-[#fff] text-center px-6">
      <h2 class="text-3xl font-bold mb-4 text-[#152a34]">Trabalhar nunca foi tão fácil</h2>
      <p class="text-gray-600 max-w-3xl mx-auto mb-10">
        O GetLance é um marketplace moderno que conecta quem precisa de um serviço a quem sabe fazer.
        Aqui você cria propostas, negocia valores com segurança e garante pagamentos com garantia GetLance.
      </p>

      <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-5xl mx-auto">
        <div class="bg-[#f6f4f1] rounded-xl p-6 shadow hover:shadow-lg transition">
          <img src="/icon-job.svg" class="h-12 mx-auto mb-4" />
          <h3 class="text-lg font-semibold mb-2">Crie sua proposta</h3>
          <p class="text-gray-500 text-sm">Publique o que precisa e receba ofertas de profissionais em minutos.</p>
        </div>

        <div class="bg-[#f6f4f1] rounded-xl p-6 shadow hover:shadow-lg transition">
          <img src="/icon-chat.svg" class="h-12 mx-auto mb-4" />
          <h3 class="text-lg font-semibold mb-2">Negocie com segurança</h3>
          <p class="text-gray-500 text-sm">Converse diretamente no chat da plataforma antes de fechar o negócio.</p>
        </div>

        <div class="bg-[#f6f4f1] rounded-xl p-6 shadow hover:shadow-lg transition">
          <img src="/icon-money.svg" class="h-12 mx-auto mb-4" />
          <h3 class="text-lg font-semibold mb-2">Pagamento com garantia GetLance</h3>
          <p class="text-gray-500 text-sm">
            O valor fica reservado e é liberado somente após o serviço ser entregue com sucesso.
          </p>
        </div>
      </div>
    </section>

    <!-- 🧭 CATEGORIAS -->
    <section id="categorias" class="bg-[#152a34] text-white py-20 text-center px-6">
      <h2 class="text-3xl font-bold mb-4">Encontre profissionais por categoria</h2>
      <p class="text-white/80 mb-10">Temos centenas de categorias para todo tipo de projeto.</p>

      <div class="flex flex-wrap justify-center gap-4 max-w-4xl mx-auto">
        <span
          v-for="cat in mockCategories"
          :key="cat"
          class="px-5 py-2 bg-white/10 rounded-full text-sm hover:bg-[#b99a52] hover:text-white cursor-pointer transition"
        >
          {{ cat }}
        </span>
      </div>
    </section>

    <!-- 🔒 SEGURANÇA -->
    <section id="seguranca" class="py-20 bg-[#f6f4f1] text-center px-6">
      <h2 class="text-3xl font-bold mb-6 text-[#152a34]">Garantia financeira GetLance</h2>
      <p class="text-gray-600 max-w-3xl mx-auto mb-8">
        A GetLance oferece um sistema de garantia que assegura que o prestador receba apenas após o serviço ser
        concluído e aprovado. Transparência e confiança de ponta a ponta.
      </p>
      
    </section>

    <!-- 🗣️ NOVA SEÇÃO: DEPOIMENTOS -->
    <section class="bg-[#fff] py-20 text-center px-6">
      <h2 class="text-3xl font-bold mb-10 text-[#152a34]">Histórias de sucesso</h2>
      <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-6xl mx-auto">
        <div
          v-for="(testimony, i) in testimonials"
          :key="i"
          class="bg-[#f6f4f1] rounded-xl shadow p-6 hover:shadow-lg transition flex flex-col justify-between"
        >
          <p class="text-gray-600 text-sm mb-4 italic">"{{ testimony.text }}"</p>
          <div class="flex items-center gap-3 mt-4">
            <!--<img :src="testimony.avatar" alt="Foto" class="h-10 w-10 rounded-full object-cover" />-->
            <div class="text-left">
              <p class="font-semibold text-[#152a34]">{{ testimony.name }}</p>
              <p class="text-xs text-gray-500">{{ testimony.role }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ⚙️ COMO FUNCIONA -->
    <section id="como-funciona" class="bg-white py-20 text-center px-6">
      <h2 class="text-3xl font-bold mb-10 text-[#152a34]">Como funciona?</h2>
      <div class="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-8">
        <div class="flex flex-col items-center">
          <div
            class="bg-[#b99a52] text-white rounded-full w-16 h-16 flex items-center justify-center text-2xl font-bold mb-4"
          >
            1
          </div>
          <h3 class="font-semibold text-lg mb-2">Crie sua conta</h3>
          <p class="text-gray-500 text-sm">Leva menos de um minuto para começar a usar a plataforma.</p>
        </div>

        <div class="flex flex-col items-center">
          <div
            class="bg-[#b99a52] text-white rounded-full w-16 h-16 flex items-center justify-center text-2xl font-bold mb-4"
          >
            2
          </div>
          <h3 class="font-semibold text-lg mb-2">Publique ou procure um trabalho</h3>
          <p class="text-gray-500 text-sm">Crie um anúncio ou busque projetos de acordo com suas habilidades.</p>
        </div>

        <div class="flex flex-col items-center">
          <div
            class="bg-[#b99a52] text-white rounded-full w-16 h-16 flex items-center justify-center text-2xl font-bold mb-4"
          >
            3
          </div>
          <h3 class="font-semibold text-lg mb-2">Finalize e receba</h3>
          <p class="text-gray-500 text-sm">Conclua o trabalho, receba o pagamento e construa sua reputação.</p>
        </div>
      </div>
    </section>

    <!-- 🚀 CTA FINAL -->
    <section class="bg-[#b99a52] text-white text-center py-16">
      <h2 class="text-3xl font-bold mb-3">Pronto para começar?</h2>
      <p class="mb-6">Crie sua conta gratuita e comece a trabalhar hoje mesmo.</p>
      <router-link
        to="/cadastro"
        class="bg-white text-[#152a34] px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition"
      >
        Criar minha conta
      </router-link>
    </section>

    <AppFooter />
  </div>
</template>

<script setup>
import {onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import AppFooter from '@/components/AppFooter.vue';

const router = useRouter();

onMounted(() => {
  const userData = localStorage.getItem('userData');
  
  if (userData) {
    router.replace('/projetos');
  }
});

const mockCategories = [
  "Reformas e Construção",
  "Design Gráfico",
  "Programação",
  "Serviços Domésticos",
  "Beleza e Estética",
  "Manutenção e Reparos",
  "Transporte e Fretes",
  "Eventos e Festas",
  "Consultoria",
];

const testimonials = [
  {
    name: "Lucas Almeida",
    role: "Designer Freelancer",
    text: "Consegui meus primeiros clientes em menos de uma semana usando o GetLance!",
    avatar: "/avatar-1.jpg",
  },
  {
    name: "Mariana Souza",
    role: "Empresária",
    text: "Contratar profissionais se tornou muito mais fácil e seguro. A plataforma é incrível!",
    avatar: "/avatar-2.jpg",
  },
  {
    name: "Carlos Mendes",
    role: "Eletricista",
    text: "Recebo projetos locais e o pagamento sempre cai direitinho. Recomendo demais!",
    avatar: "/avatar-3.jpg",
  },
];
</script>
